module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.68ed1dac06bf0409c18a.woff";


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/css/fonts/glyphicons.halflings.pro/glyphicons-halflings-regular.woff
// module id = ../../../../../src/assets/css/fonts/glyphicons.halflings.pro/glyphicons-halflings-regular.woff
// module chunks = 2